import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import {
  Page404,
  Page500,
  LoginPage,
  RegisterPage,
  DashboardPage,
  VerifyPage,
  TrackPage,
  RidersPage,
  ServiceTicketsPage,
  AccountPage,
  SecurityPage,
  TripsPage,
  RoutePage,
  ReplayPage,
  VehicleAnalyticsPage,
  ResetPassword,
  WelcomePage,
  AllTripsPage,
  AlertsPage,
  ReportsPage,
  UserAnalyticsPage,
  VehiclePage,
  StationsPage,
  NotificationPage,
} from './pages';
import { LoginLayout, ReportsLayout, SettingsLayout } from './layouts';

import store from './store';
import AppLayout from './layouts/App/AppLayout';
import { getPersistedState } from './utils';
import { userSlice } from './services/slices/user/userSlice';

const caseSensitive = true;
const root = true;
const index = true;
const showParams = true;
const subRoute = true;

export default () =>
  createBrowserRouter([
    {
      path: '*',
      element: <Page404 />,
    },
    {
      element: <LoginLayout />,
      errorElement: <Page500 />,
      children: [
        { path: '/login', caseSensitive, element: <LoginPage /> },
        { path: '/register', caseSensitive, element: <RegisterPage /> },
        { path: '/reset-password/:emailId', caseSensitive, element: <ResetPassword /> },
        {
          path: '/verification/:emailId/:token',
          caseSensitive,
          element: <VerifyPage verification />,
        },
      ],
    },
    {
      path: '/',
      handle: { root },
      element: <AppLayout />,
      loader: () => {
        if (getPersistedState('token')) {
          store.dispatch(
            userSlice.endpoints.getUserDetails.initiate(null, { forceRefetch: false }),
          );
        }
        return '';
      },
      errorElement: <Page500 />,
      children: [
        {
          index,
          caseSensitive,
          handle: { root },
          element: <WelcomePage />,
        },
        {
          path: 'dashboard',
          caseSensitive,
          handle: { name: 'Dashboard', root },
          errorElement: <Page500 />,
          element: <DashboardPage />,
        },
        {
          path: 'insights/alerts',
          caseSensitive,
          handle: { name: 'Alerts', root },
          errorElement: <Page500 />,
          element: <AlertsPage />,
        },
        {
          path: 'track',
          caseSensitive,
          handle: { name: 'Track', index },
          errorElement: <Page500 />,
          element: <TrackPage />,
        },
        {
          path: 'vehicles',
          caseSensitive,
          handle: { name: 'All Vehicles', root },
          errorElement: <Page500 />,
          element: <VehiclePage />,
        },
        {
          path: 'replay',
          handle: { name: 'Replay', showParams: false },
          element: <ReplayPage />,
          caseSensitive,
        },
        {
          path: 'settings',
          caseSensitive,
          element: <SettingsLayout />,
          handle: { name: '', root },
          errorElement: <Page500 />,
          children: [
            {
              path: 'account',
              handle: { name: 'Account', showParams: false },
              element: <AccountPage />,
              caseSensitive,
            },
            {
              path: 'security',
              handle: { name: 'Security' },
              element: <SecurityPage />,
              caseSensitive,
            },
          ],
        },
      ],
    },
  ]);
